var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8984 14.1964L22.725 15.0229L23.5515 14.1964L22.725 13.3698L21.8984 14.1964ZM7.87141 13.0275C7.22584 13.0275 6.70249 13.5508 6.70249 14.1964C6.70249 14.842 7.22584 15.3653 7.87141 15.3653L7.87141 13.0275ZM18.0493 19.6986L22.725 15.0229L21.0719 13.3698L16.3962 18.0455L18.0493 19.6986ZM22.725 13.3698L18.0493 8.69417L16.3962 10.3473L21.0719 15.0229L22.725 13.3698ZM21.8984 13.0275L7.87141 13.0275L7.87141 15.3653L21.8984 15.3653L21.8984 13.0275Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.6833480db4d78bb23166867f8ddd7618.svg";
export { ForwardRef as ReactComponent };